import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import styles from '../shared/styles';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import Smartuploader from '../../../../components/Smartuploader';
import faCaretRight from '@fortawesome/fontawesome-free-solid/faCaretRight';
import faCaretDown from '@fortawesome/fontawesome-free-solid/faCaretDown';
import { DivisionLabel, HelperText, RowDivision } from '../shared/styled-components';
import { soundcastManager } from '../../../../helpers/managers';
import { canUserAccessFeature } from '../../../../helpers/userinfoHelper';
import { HigherPlanTag } from '../../../../styles/styled';
import ToggleWithInput from '../common/ToggleWithInput';

class IntroOutro extends Component {
  constructor (props) {
    super(props);

    this.state = {
      intro: props.intro,
      outro: props.outro,
      disableReProcessSoundcast: props.disableReProcessSoundcast,
    };

    this.onRemoveAudio = this.onRemoveAudio.bind(this);
    this.updateSoundcast = this.updateSoundcast.bind(this);
    this.updateSoundcastTree = this.updateSoundcastTree.bind(this);
  }

  updateSoundcastTree (path, value, remove = false) {
    const { soundcastId, autoSave } = this.props;
    if (remove) {
      return soundcastManager.removeProp(soundcastId, `${path}`);
    }

    if (autoSave) {
      soundcastManager.saveProp(soundcastId, `${path}`, value);
    }
  }

  updateSoundcast (statekey, remove = false) {
    return ({ filename }) => {
      const url = `https://app.mysoundwise.com/tracks/${filename}`;
      this.setState({
        [statekey]: (remove) ? '' : url,
        'disableReProcessSoundcast': false,
        'introOutroUpdated': true
      }, () => {
        const newvalue = this.state[statekey];
        console.log(`***** 2 updateSoundcast filename ${filename} statekey ${statekey} remove ${remove} newvalue ${newvalue}`);
        this.updateSoundcastTree(statekey, newvalue, remove);
        this.props.onChange('introOutroUpdated', true);
        this.props.onChange('disableReProcessSoundcast', false);
        this.props.onChange(statekey, newvalue);
      });
    };
  }

  onRemoveAudio (statekey) {
    return () => {
      const oldvalue = this.state[statekey];
      this.updateSoundcast(statekey, true)({
        filename: oldvalue.split('/').pop(),
      });
    };
  }

  onFilepondProcess (statekey, cb = () => {}) {
    return (error, filepond) => {
      if (error) {
        return console.error('Unable to process file', error);
      }

      const { filenameWithoutExtension: filename, serverId, source } = filepond;
      if (!isEmpty(serverId)) {
        if (serverId.slice(0,5) === 'Error') {
          console.error(`Unable to save on S3 file ${statekey} ${serverId}`);
          return alert(`Unable to save on S3 file ${statekey}`);
        }

        let { url } = JSON.parse(serverId);
        const oldvalue = this.state[statekey];
        this.setState({
          [statekey]: url,
        }, () => {
          cb(filepond, oldvalue);
        });
      }
    };
  }

  onFilepondFileRemove (statekey = 'intro', cb = () => {}) {
    return (error, filepond) => {
      if (error) {
        return console.error('Unable to remove from S3 file', error);
      }

      console.log(`***** 1 introoutro onFilepondFileRemove statekey ${statekey}`);

      const oldvalue = this.state[statekey];
      this.setState({
        [statekey]: ''
      }, () => {
        cb(filepond, oldvalue);
      });
    };
  }

  renderContent (fileuploader) {
    const {
      statekey,
      value,
      filename,
      title,
    } = fileuploader;
    const { soundcastId, publisherId, persistUploaderOnSuccess } = this.props;

    if (!isEmpty(value) && !persistUploaderOnSuccess) {
      return (
        <div style={{ padding: '0 20px 20px' }}>
          <span style={{ ...styles.introOutroHeadText, padding: '20px 0' }}>{title}</span>
          <div style={styles.introOutroSaved}>
            <div>
              {filename} <span style={styles.introOutroSavedTxt}>saved</span>
            </div>
            <div>
              <span
                style={{ ...styles.multipleInputRight, ...styles.introOutroRemove }}
                onClick={this.onRemoveAudio(statekey)}
              >
                <i className="fa fa-times " aria-hidden="true"/>
              </span>
            </div>
          </div>
        </div>
      );
    }

    return (
      <React.Fragment>
        <span style={styles.introOutroHeadText}>{title}</span>
        <Smartuploader
          fileuploader={{
            server: '/api/upload',
            onprocessfile: this.onFilepondProcess(statekey, this.updateSoundcast(statekey)),
            onremovefile: this.onFilepondFileRemove(statekey, this.updateSoundcast(statekey, true)),
            onerror: this.onFilepondFileRemove(statekey, this.updateSoundcast(statekey, true)),
            acceptedFileTypes: ['audio/*'],
            fileRenameFunction: file => {
              return `${filename}${file.extension}`;
            },
            fileMetadataObject: { soundcastId, publisherId, destinationField: statekey },
          }}
        />
      </React.Fragment>
    );
  }

  render () {
    const { intro, outro, disableReProcessSoundcast = false } = this.state;
    const {
      show,
      showHistoricalToggle,
      soundcastId,
      handleShow,
      applyHistoricallyIntroOutro,
      overlayDuration,
      onNoIntroOutroAlert,
      onFeatureNotAllowed,
      onChange,
      disableReProcessByPlan,
    } = this.props;
    const accessible = canUserAccessFeature('SOUNDCAST_INTRO_OUTRO');
    const fileuploaders = [{
      statekey: 'intro',
      value: intro,
      filename: `${soundcastId}_intro`,
      title: 'Upload Intro',
    }, {
      statekey: 'outro',
      value: outro,
      filename: `${soundcastId}_outro`,
      title: 'Upload Outro',
    }];

    return (
      <RowDivision className="row">
        <div id="intro-outro" className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
          <DivisionLabel style={{ cursor: 'pointer' }} onClick={handleShow}>
            <div style={{ display: 'inline-block', width: 15 }}>
              <FontAwesomeIcon icon={show ? faCaretDown : faCaretRight}/>
            </div>
            Intro and Outro
            {!accessible && <HigherPlanTag className="margin-one-left"/>}
            <HelperText>
              Automatically add intro/outro to tracks. (mp3 or m4a file accepted)
            </HelperText>
          </DivisionLabel>
          {show && (
            <div className="row">
              {fileuploaders.map((fileuploader, index) => {
                return (
                  <div key={`intro-outro-${index}`} className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div style={styles.introOutroWrapper}>
                      {this.renderContent(fileuploader)}
                    </div>
                  </div>
                );
              })}
              {showHistoricalToggle && (
                <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12" style={styles.toggleOptionsMargin}>
                  <ToggleWithInput disabled={disableReProcessSoundcast}
                                   disabledByPlan={disableReProcessByPlan}
                                   mainFlag={applyHistoricallyIntroOutro}
                                   inputValue={overlayDuration}
                                   onChangeToggleFn={() => {
                                     if (intro || outro) {
                                       onChange('applyHistoricallyIntroOutro', !applyHistoricallyIntroOutro);
                                     } else {
                                       if (applyHistoricallyIntroOutro) {
                                         onChange('applyHistoricallyIntroOutro', !applyHistoricallyIntroOutro);
                                       } else {
                                         onNoIntroOutroAlert();
                                       }
                                     }
                                   }}
                                   onChangeValueFn={e => onChange('overlayDuration', Number(e.target.value))}
                                   mainText={'Apply to existing tracks'}
                                   subText={'(This option adds updated intro/outro to all published tracks and replaces any existing intro/outro)'}
                                   inputLabel={'Overlap with main audio: '}
                                   inputUnits={'second(s)'}
                                   onFeatureNotAllowed={ () => onFeatureNotAllowed() }
                  />
                </div>)}
            </div>
          )}
        </div>
      </RowDivision>
    );
  }
}

IntroOutro.propTypes = {
  show: PropTypes.bool,
  showHistoricalToggle: PropTypes.bool,
  intro: PropTypes.string,
  outro: PropTypes.string,
  soundcastId: PropTypes.string,
  onChange: PropTypes.func,
  handleShow: PropTypes.func,
  persistUploaderOnSuccess: PropTypes.bool,
  autoSave: PropTypes.bool,
  applyHistoricallyIntroOutro: PropTypes.bool,
  overlayDuration: PropTypes.number,
  onNoIntroOutroAlert: PropTypes.func,
  disableReProcessSoundcast: PropTypes.bool,
  onFeatureNotAllowed: PropTypes.func,
};

IntroOutro.defaultProps = {
  show: false,
  showHistoricalToggle: false,
  intro: '',
  outro: '',
  publisherId: '',
  soundcastId: '',
  onChange: () => {
  },
  handleShow: () => {
  },
  persistUploaderOnSuccess: false,
  autoSave: false,
  applyHistoricallyIntroOutro: false,
  overlayDuration: 5,
  onNoIntroOutroAlert: () => {
  },
  disableReProcessSoundcast: false,
  onFeatureNotAllowed: () => {},
};

export default IntroOutro;
